import { NgModule } from '@angular/core';
import { BaseStorefrontModule } from "@spartacus/storefront";
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { SpartacusFeaturesModule } from './spartacus-features.module';
import { CustomProdPgModule } from '../custom-prod-pg/custom-prod-pg.module';

@NgModule({
  declarations: [],
  imports: [

    SpartacusFeaturesModule,
    SpartacusConfigurationModule,
    BaseStorefrontModule,
    CustomProdPgModule,
  ],
  exports: [BaseStorefrontModule]
})
export class SpartacusModule { }
